import styled from "styled-components"

import { Box, Flex, Typography } from "components/common"

export const Section = styled(Flex).attrs((props) => ({
  display: { _: "block", tablet: "flex" },
  gutter: { tablet: 2 },
  mb: 2,
  ...props,
}))``
export const SectionLeft = styled(Box).attrs((props) => ({
  width: { tablet: 1 / 6 },
  ...props,
}))``
export const SectionRight = styled(Box).attrs((props) => ({
  flex: { tablet: "1" },
  ...props,
}))``

export const PageTitle = styled(Typography).attrs((props) => ({
  as: "h1",
  color: "black",
  fontSize: "32px",
  fontWeight: 700,
  lineHeight: "36px",
  mb: 6,
  mt: "46px",
  ...props,
}))`
  word-wrap: break-word;
`

export const SectionTitle = styled(Typography).attrs((props) => ({
  color: "black",
  fontSize: 16,
  letterSpacing: "1px",
  lineHeight: "1.3",
  mb: 1,
  mt: { tablet: "3px" },
  textAlign: { tablet: "right" },
  ...props,
}))`
  text-transform: uppercase;
  word-wrap: break-word;
`

export const Paragraph = styled(Typography).attrs((props) => ({
  color: "black",
  fontSize: "16px",
  letterSpacing: "-0.02em",
  light: true,
  lineHeight: "22px",
  mb: 2,
  ...props,
}))``

export const SectionList = styled(Box).attrs((props) => ({
  as: "ul",
  fontSize: { _: "14px", tablet: "16px" },
  lineHeight: { tablet: "18px" },
  mb: "3px",
  pl: "20px",
  ...props,
}))`
  font-weight: 300;
  letter-spacing: 0.5px;
`
export const TitleWithLine = styled(Typography).attrs((props) => ({
  as: "h3",
  fontSize: 18,
  marginTop: props.subtitle ? { _: 1, tablet: 2 } : "",
  mb: 4,
  textAlign: "center",
  ...props.theme.titleWithLine,
  ...props,
}))`
  background: linear-gradient(
    transparent,
    ${(props) => props.theme.titleWithLine.bg}
  );
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 28% 1px;
  ${(props) => props.theme.mediaQueries.tablet`
     background-size: 10% 1px;
  `}
`

export const InfoSectionTitle = styled(Typography).attrs((props) => ({
  as: "h2",
  fontSize: "26px",
  fontWeight: 500,
  letterSpacing: 0,
  lineHeight: "30px",
  mb: 1,
  ...props,
}))``

export const DetailTitle = styled(Typography).attrs((props) => ({
  fontSize: "16px",
  fontWeight: 700,
  letterSpacing: "-0.02em",
  lineHeight: "22px",
  mb: 1,
  ...props,
}))``

export const DetailBody = styled(Typography).attrs((props) => ({
  fontSize: "16px",
  fontWeight: 300,
  lineHeight: "22px",
  mb: 4,
  ...props,
}))`
  :last-child {
    margin-bottom: 0;
  }
`
